module.exports = __webpack_public_path__ + "static/media/QualtricsXM_Step1_Image24.c35fca05.jpg";